import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Recipient } from './recipient.interface';
import { getUniqueUserId } from '../utils';

export const recipientAdapter: EntityAdapter<Recipient> = createEntityAdapter<
  Recipient
>({ selectId: getUniqueUserId });
